import { render, staticRenderFns } from "./singleProgramItem_slotPop.vue?vue&type=template&id=ee972f82"
import script from "./singleProgramItem_slotPop.vue?vue&type=script&lang=js"
export * from "./singleProgramItem_slotPop.vue?vue&type=script&lang=js"
import style0 from "./singleProgramItem_slotPop.vue?vue&type=style&index=0&id=ee972f82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports